// import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index'
import tooltipDirective from './directives/tooltip'
// import axios from 'axios'
import { axios } from '@/common/api.service.js'

console.log('HERE MainJS')
//----------------------
// notifications
//----------------------
import Notifications from '@kyvg/vue3-notification'
//----------------------
// sidebar
//----------------------
// import VueSidebarMenuAkahon from "vue-sidebar-menu-akahon";
//----------------------
// table
//----------------------
import VueGoodTablePlugin from 'vue-good-table-next'
//----------------------
// dropdowns
//----------------------
import VueSelect from 'vue-select'
//----------------------
// enhanced check
//----------------------
import EnhancedCheck from 'vue-enhanced-check'
//----------------------
// multiselect
//----------------------
import Multiselect from 'vue-multiselect'
//----------------------
// event bus
//----------------------
import mitt from 'mitt'
//----------------------
// bootstrap
//----------------------
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//----------------------
// dropdowns
//----------------------
import 'vue-select/dist/vue-select.css'
//----------------------
// styles
//----------------------
import '@/styles/bb.scss'
import '@/styles/bb.css'
import '@/styles/vue-multiselect.css'
import '@/styles/bb_bootstrap.css'

// import { EnhancedCheck, EnhancedCheckGroup, EnhancedCheckRadio, EnhancedToggle } from 'vue-enhanced-check'
// import VueSidePanel from 'vue3-side-panel';
// import 'vue3-side-panel/dist/vue3-side-panel.css'
//-----------------------------
// global javascript functions
//-----------------------------
const global = {
  //-------------------------
  // display console message
  //-------------------------
  dcm(msg) {
    console.log('------------------------')
    console.log(msg)
    console.log('------------------------')
  },
  //-------------------------
  // display combatants
  //-------------------------
  displayCombatants(label, array) {
    console.log('------------------------')
    console.log(label + '...')
    console.log('------------------------')
    for (let i = 0; i < array.length; i++) {
      console.log('combatant idx = ' + i + ' name = ' + array[i].name)
    }
  },
  //----------------------------
  // hide zero and minus values
  //----------------------------
  hideZeroMinusValues(value) {
    if (value == 0 || value == -999) {
      return ''
    } else {
      return value
    }
  },
  //------------------
  // hide zero values
  //------------------
  hideZeroValues(value) {
    if (value == 0) {
      return ''
    } else {
      return value
    }
  },
  //-----------------------------
  // hide zero values but signed
  //-----------------------------
  hideZeroValuesButSigned(value) {
    if (value == 0) {
      return ''
    }
    if (value > 0) {
      return `+${value}`
    }
    return value
  },
  //-------------
  // two decimals
  //-------------
  twoDecimal(value) {
    if (value === null || value === undefined || value === '') {
      return ''
    }
    const n = Number(value)
    if (Number.isNaN(n)) return ''
    return n.toFixed(2)
  },
  //-------------
  // one decimal
  //-------------
  oneDecimal(value) {
    if (value == 0) {
      return ''
    }
    const n = Number(value)
    if (Number.isNaN(n)) return ''
    if (n === 0) return 0
    return n.toFixed(1)
  },
}
//----------------------------
// global vars (bbAPIRequest)
//----------------------------
window.bbAPIRequest = (endpoint, slug, deleteInd) => {
  var response = {
    endpoint: '',
    method: '',
  }
  if (slug !== undefined && slug !== null && slug !== '') {
    response.endpoint = `${endpoint}` + `${slug}/`
    if (deleteInd) {
      response.method = 'DELETE'
    } else {
      response.method = 'PUT'
    }
  } else {
    response.endpoint = endpoint
    response.method = 'POST'
  }
  return response
}
//----------------------------
// global vars (bbErrorKey)
//----------------------------
window.bbErrorKey = (err) => {
  var errorkey = ''
  var key = ''

  try {
    errorkey = err['errorKey']
    try {
      key = errorkey.toString()
    } catch (err) {
      key = err
    }
    return key
  } catch (err) {
    return err
  }
}
//----------------------------
// global vars (bbErrorMsg)
//----------------------------
window.bbUiErrorMsg = (message) => {
  const narrative = (message ?? '')
    .toString()
    .trim()
    .replace(/^\*+\s*/, '')
    .replace(/\s*\*+$/, '')
    .replace(/[.!?]+$/, '')
    .trim()

  return narrative ? `*** ${narrative} ***` : '***.'
}

window.bbErrorMsg = (err) => {
  var errormsg = ''
  var msg = ''

  try {
    errormsg = err['errorMsg']
    try {
      msg = errormsg.toString()
    } catch (err) {
      msg = err
    }
    return msg
  } catch (err) {
    return err
  }
}
//----------------------------
// displayResponseData
//----------------------------
window.displayResponseData = function (payload) {
  console.log('Object.keys = ' + Object.keys(payload))
  console.log('Object.values = ' + Object.values(payload))

  if (payload) {
    console.log('------------------------------------')
    console.log('displayResponseData....')
    console.log('length = ' + payload.length)
    for (var i = 0; i < payload.length; i++) {
      const row = payload[i]

      for (var j = 0; j < Object.keys(row).length; j++) {
        const key = Object.keys(row)[j]
        const val = Object.values(row)[j]
        console.log('row: ' + i + ' pair: ' + j + ' key: ' + key + ' / value: ' + val)
      }
    }
    console.log('------------------------------------')
  }
}
//--------------
// displayPairs
//--------------
window.displayPairs = function (payload) {
  if (payload) {
    console.log('------------------------------------')
    console.log('displayPairs....')

    for (var key of Object.keys(payload)) {
      console.log(key, ' -> ', payload[key])
    }
    console.log('------------------------------------')
  }
}
//--------------------
// displayObjectArray
//--------------------
window.displayObjectArray = function (payload) {
  if (payload) {
    console.log('------------------------------------')
    console.log('displayObjectArray....')
    console.log('rows = ' + payload.length)
    for (var i = 0; i < payload.length; i++) {
      const row = payload[i]
      console.log('---------------------------')
      console.log('row ' + i + '...')
      for (var key of Object.keys(row)) {
        console.log(key, ' -> ', row[key])
      }
    }
    console.log('------------------------------------')
  }
}
//----------------------------
// getKeyValues
//----------------------------
window.getKeyValues = function (payload) {
  var values = []

  if (payload) {
    console.log('------------------------------------')
    console.log('getKeyValues....')
    console.log('length = ' + payload.length)
    for (var i = 0; i < payload.length; i++) {
      const row = payload[i]

      for (var j = 0; j < Object.keys(row).length; j++) {
        console.log('Value = ', Object.values(row)[j])
        values.push(Object.values(row)[j])
      }
    }
    return values
  }
  return null
}
//----------------------------
// loadResponseErrors
//----------------------------
window.loadResponseErrors = function (payload) {
  let errors = []
  if (payload) {
    for (var key of Object.keys(payload)) {
      for (var value of payload[key]) {
        // console.log(key + " -> " + value);
        errors.push(value)
      }
    }
  }
  return errors
}
//=================================================================
// getErrorMessage
//----------------------------
window.getErrorMessage = function (error) {
  console.log('in geterrormessage = ' + error)

  const errorDict = {
    errorKey: '',
    errorMsg: 'An unexpected error has occured.\nPlease contact the administrator.',
  }
  //--------------------------------------------------------------
  // request made - server responded with status out of 2xx range
  //--------------------------------------------------------------
  if (error.response) {
    //--------------------------------------------------------------
    // request made - server error OR csrf error
    //--------------------------------------------------------------
    if (error.response.status == 500 || error.response.status == 403) {
      console.log('Error1', error.message)
      return errorDict
    } else if (error.response.data) {
      let errorData = Object.values(error.response.data)[0]

      if (errorData) {
        errorDict.errorMsg = errorData
        errorDict.errorKey = Object.keys(error.response.data)[0]
        console.log('getErrorMessage -> ' + errorDict.errorMsg)
        console.log('getErrorKey -> ' + errorDict.errorKey)
      } else {
        console.log('Error2', error.message)
      }
    } else {
      console.log('Error3', error.message)
    }
    //-------------------------------------
    // request made - no response received
    //-------------------------------------
  } else if (error.request) {
    console.log('Error4', error.message)
    //-------------------------------------
    // unexpected error
    //-------------------------------------
  } else {
    console.log('Error5', error.message)
  }
  return errorDict
}
//=================================================================
// deepCopy (for use in js files)
//--------------------------------
window.$deepCopy = function (payload) {
  // handle undefined or null without throwing JSON parse errors
  if (payload === undefined || payload === null) {
    return payload
  }
  return JSON.parse(JSON.stringify(payload))
}
//----------------------
// global error handler
//----------------------
window.onerror = function (message, source, line, column, error) {
  console.log('---------------------------------')
  console.log('ERROR HANDLER...')
  console.log('message: ' + message)
  console.log('source: ' + source)
  console.log('line: ' + line)
  console.log('column: ' + column)
  console.log('error: ' + error)
  console.log('---------------------------------')
  alert('error: ' + error)
}
//=======================================================
// set csrf token function
//-----------------------------
async function setCsrfToken() {
  try {
    await axios.get('/set-csrf/')

    // ensure CSRF token available in cookie
    const csrfToken = document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrftoken='))
      ?.split('=')[1]

    if (csrfToken) {
      axios.defaults.headers.common['X-CSRFTOKEN'] = csrfToken
      // console.log('7. X-CSRFTOKEN header set:', csrfToken)
    }
    // store.dispatch('auth/storeCsrfToken', response.data.message)
  } catch (error) {
    console.error('Error setting CSRF token:', error)
  }
}
//=======================================================
// initialise app
//----------------
async function initialiseApp() {
  // console.log('Initialising app...')
  //----------------
  // set csrf token
  //----------------
  await setCsrfToken()
  //-----------------------
  // continue creating app
  //-----------------------
  try {
    //------------
    // create app
    //------------
    const emitter = mitt()
    const app = createApp(App)
    // remove all listeners for all events
    emitter.all.clear()
    //----------
    // app uses
    //----------
    app.use(router)
    app.use(store)
    app.use(VueGoodTablePlugin)
    app.use(Notifications)
    app.use(EnhancedCheck)

    app.config.productionTip = false

    // app.component("vue-sidebar-menu-akahon", VueSidebarMenuAkahon);

    app.component('v-select', VueSelect)
    app.component('vue-multiselect', Multiselect)
    app.directive('tooltip', tooltipDirective)

    app.provide('global', global)
    app.config.globalProperties.emitter = emitter

    // global function to deep copy a payload (use $deepCopy in vue)
    app.config.globalProperties.$deepCopy = function (payload) {
      return JSON.parse(JSON.stringify(payload))
    }

    app.mount('#app')
  } catch (error) {
    console.error('Error making API request:', error)
  }
}
//=======================================================
// call initialise app
//---------------------
initialiseApp()
